// Optional: Define operator constants
export const FILTER_OPERATORS = {
  CONTAINS: ':',
  NOT_CONTAINS: '!:',
  EQUALS: '=',
  NOT_EQUALS: '!=',
  LESS_THAN: '<',
  LESS_THAN_OR_EQUAL: '<=',
  GREATER_THAN: '>',
  GREATER_THAN_OR_EQUAL: '>=',
  STARTS_WITH: '^',
  NOT_STARTS_WITH: '!^',
} as const;

export const STRING_FILTER_OPERATORS = [
  FILTER_OPERATORS.CONTAINS,
  FILTER_OPERATORS.NOT_CONTAINS,
  FILTER_OPERATORS.EQUALS,
  FILTER_OPERATORS.NOT_EQUALS,
  FILTER_OPERATORS.STARTS_WITH,
  FILTER_OPERATORS.NOT_STARTS_WITH,
];
